import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import copyToClipboard from 'util/clipboard/copyToClipboard';

interface SuccessfulPipeBioTokenCreationModalProps {
  token: string;
  onRequestClose: () => void;
}

export function SuccessfulPipeBioTokenCreationModal({
  token,
  onRequestClose,
}: SuccessfulPipeBioTokenCreationModalProps): JSX.Element {
  const button = {key: 'confirm', text: 'Done', cancel: true, style: ButtonStyle.PRIMARY};
  const text =
    'Make sure to copy your account token to your PipeBio profile now, as it cannot be retrieved later.';
  return (
    <Modal
      title="PipeBio Account Token Creation Confirmation"
      onRequestClose={onRequestClose}
      closeable={true}
      buttons={[button]}
      titleIcon="done"
    >
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>PipeBioAccount Token (click to copy)</Label>
            <FormInput
              readOnly={true}
              selectAllOnClick={true}
              value={`${token}`}
              onClick={(e) => {
                copyToClipboard(token, {
                  showToastOnSuccess: true,
                  toastText: 'PipeBio account token copied to clipboard!',
                });
              }}
            />
            <div className="u-spacing">
              <InlineBanner bannerType={InlineBannerType.WARNING} text={text} />
            </div>
          </FormGroup>
        </Col>
      </Row>
    </Modal>
  );
}

export default SuccessfulPipeBioTokenCreationModal;
